<template>
  <div class="container">
    <div class="footer">
      <p>copyright &copy;</p>
    </div>
  </div>
</template>

<style scoped>
.container {
  font-family: boombox, Helvetica, Arial, sans-serif;
  min-width: 300px;
  transition: all 0.25s ease-in-out;
}
</style>